import { render, staticRenderFns } from "./PriceEdit.vue?vue&type=template&id=4f1dfd63&scoped=true"
import script from "./PriceEdit.vue?vue&type=script&lang=js"
export * from "./PriceEdit.vue?vue&type=script&lang=js"
import style0 from "./PriceEdit.vue?vue&type=style&index=0&id=4f1dfd63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1dfd63",
  null
  
)

export default component.exports